import React from 'react';
import { Redirect } from 'react-router-dom';

import { resolveRedirect } from '../util/redirectRules';

export const redirectLegacyPath = location => {
  const target = resolveRedirect(location.pathname);
  if (!target) {
    return null;
  }

  return (
    <Redirect
      to={{
        pathname: target,
        search: location.search,
        hash: location.hash,
      }}
    />
  );
};
